<template>
  <ul :style="{left:(leftOffset)+'px',width:leftOffset+'px'}">
    <li v-for="(item,index) in menuData" :key="level+'-'+parentOrder+'-'+index" @mouseover.self="onLiMouseover({level,parentOrder,index},item)">
      <template v-if="!item.children||!item.children.length">
        <menu-item :title="item.title" />
        +{{ level }} +{{ index }}--{{ parentOrder }}
      </template>
      <template v-else>
        <!--<menu-item :title="item.title" />-->
        {{ item.title }}- {{ level }} {{ index }}--{{ parentOrder }}
        <sub-menu v-show="deduceShowSubMenu(index)" :key="level+'-'+parentOrder" :menu-context="menuContext" :menu-data="item.children" :level="level+1" :parent-order="index" />
      </template>
    </li>
  </ul>
</template>

<script>
import menuItem from './menuItem'
export default {
  name: 'SubMenu',
  components: { menuItem },
  props: {
    menuContext: { type: Object, required: true },
    leftOffset: { type: Number, default: 200 },
    itemHeight: { type: Number, default: 26 },
    menuData: { type: Array, required: true },
    level: { type: Number, default: 1, required: false }, // 所在组的级别-不需要外边传递
    parentOrder: { type: Number, default: 0, required: false } // 父级所在组的顺序-不需要外边传递
  },
  data() {
    return {
      currentSelectedItem: null,
      currentSelectedItemId: { level: '', parentOrder: '', index: '' }, // 选择元素的坐标id
      showSubMenu: false
    }
  },
  computed: {
  },
  methods: {
    deduceShowSubMenu(parentOrder) {
      return this.currentSelectedItemId.index === parentOrder
    },
    onLiMouseover({ level, parentOrder, index }, item) {
      this.currentSelectedItem = item
      this.currentSelectedItemId = { level, parentOrder, index }

      // todo 计算当前展开的最大孩子数量
      const maxChildrenCount = item.children && item.children.length || 0

      this.menuContext.deduceMenuLayout({ currentLevel: level, maxChildrenCount })
    }
  }
}
</script>

<style scoped>

</style>
